const content = [
    // 首页/封面
    {
        key: "front",
        type: "frontPage",
        content: [{
                key: "front1",
                type: 'frontCover',
                img: require('@/assets/images/books/book1/front/top-img.png'),
            },
            {
                key: "front2",
                type: 'title-1',
                text: '机械制图与AutoCAD'
            },
            {
                key: "front3",
                type: 'frontCover',
                img: require('@/assets/images/books/book1/front/front-img.png'),
            },
        ]
    },
    // 小标题
    {
        key: 'section1.1',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '一、本课程的研究对象', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    // 正文
    {
        key: 'section1.1.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.1.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '在工程技术中，为了准确表示工程对象的形状、结构、尺寸和技术要求等，根据投影原理、标准或有关规定表示工程对象，并有必要的技术说明的图，称为图样。在产品的设计、制造、安装和使用等环节中，图样是表达和交流技术思想的重要工具，称为“工程界的语言”。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 正文
    {
        key: 'section1.1.2', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.1.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '机器都是由若干零件组成的，要制造出合格的机器，必须首先加工出合格的零件，这就需要在加工零件时严格按照图样进行加工。如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.1.2.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '0-1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.1.2.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示，阀盖的零件图能够准确表示阀盖的形状、尺寸、表面结构等加工要求，工厂按照该零件图才能加工出合格的阀盖。零件加工出来以后，还需要按照一定的装配关系组合起来，才能形成合格的机器，实现预先设定的功能。如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.1.2.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '0-2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.1.2.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示，千斤顶的装配图准确表示了千斤顶的工作原理和传动方式，以及其中各零件之间的装配关系等。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 正文
    {
        key: 'section1.1.3', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.1.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '在机械工程领域，零件图和装配图统称为机械图样。本课程就是研究机械图样绘制原理和识读方法的一门专业基础课程。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 小标题
    {
        key: 'section1.2',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '二、本课程的内容要求', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    // 正文
    {
        key: 'section1.2.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.2.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '本课程的主要内容包括', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.2.1.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '7', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.2.1.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '部分：机械制图的基本知识与技能、立体的投影规律及应用、组合体及轴测图的画法、机件常用的表示方法、标准件与常用件的画法、零件图与装配图、', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.2.1.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AutoCAD', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.2.1.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的基本操作及应用。通过学习，学生应达到以下要求。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 正文
    {
        key: 'section1.2.2', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.2.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.2.2.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.2.2.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）严格执行机械制图的有关国家标准和规定。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 正文
    {
        key: 'section1.2.3', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.2.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.2.3.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.2.3.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）具备尺规绘图和徒手绘图的技能。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section1.2.4', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.1.2.2.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/图0-1阀盖的零件图.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">0-1<\/i> 阀盖的零件图", // 图片标题
                // hasBack: 1,
                heightNoLimit: 1,
                // titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 三维模型，
    {
        key: 'section1.2.5', // *必填* 唯一标识
        type: '3DModel', // *必填* 类型：音频
        title: '三维模型', // 标题
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 音频列表
            {
                key: 'section2.1.2.3.1', // *必填* 唯一标识
                url: 'https://code.bjjqe.net/2/2/15/jxztycad-sys/0-1.htm', // *必填* 地址
                cover: require("@/assets/images/books/bookExample/introduction/threeD-cover-1.png"), // 封面
                title: '图0-1 三维模型', // 标题
                titleStyle: {

                }
            },
        ]
    },
    //
    {
        key: 'section1.2.6', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.1.2.2.3', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/图0-2千斤顶的装配图.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">0-2<\/i> 千斤顶的装配图", // 图片标题
                // titlePosition: 'top', // 标题位置， 默认为bottom
                heightNoLimit: 1,
                titleStyle: {

                }
            }
        ],
    },
    // 三维模型
    {
        key: 'section1.2.7', // *必填* 唯一标识
        type: '3DModel', // *必填* 类型：音频
        title: '三维模型', // 标题
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 音频列表
            {
                key: 'section1.2.7.1', // *必填* 唯一标识
                url: 'https://code.bjjqe.net/2/2/15/jxztycad-sys/0-2.htm', // *必填* 地址
                cover: require("@/assets/images/books/bookExample/introduction/threeD-cover-1.png"), // 封面
                title: '图0-2 三维模型', // 标题
                titleStyle: {

                }
            },
        ]
    },
    // 正文
    {
        key: 'section1.2.8', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.2.8.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.2.8.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.2.8.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）掌握正投影的基本原理及应用。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 正文
    {
        key: 'section1.2.9', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.2.9.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.2.9.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '4', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.2.9.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）具备对立体的空间想象能力。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 正文
    {
        key: 'section1.2.10', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.2.10.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.2.10.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '5', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.2.10.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）具备识读和绘制机械图样的技能。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    {
        key: 'section1.2.11', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.2.11.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.2.11.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '6', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.2.11.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）具备用AutoCAD软件绘制机械图样的技能。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    {
        key: 'section1.2.12', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.2.12.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.2.12.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '7', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.2.12.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）养成认真负责的工作态度和严谨细致的工作作风。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    // 小标题
    {
        key: 'section1.3',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '三、本课程的学习方法', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    {
        key: 'section1.3.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.3.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '本课程是一门实践性很强的专业基础课，其核心内容是如何正确运用正投影原理和国家标准快速识读与绘制机械图样。因此，在学习过程中，学生不能仅满足于对理论和标准的理解，还必须将这些理论知识和生产实际密切结合。为了学好本课程，建议采用以下几种学习方法。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    {
        key: 'section1.3.2', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.3.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.3.2.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.3.2.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）图物转换。本课程的核心内容之一是如何利用二维平面图形来表示三维立体，以及通过二维平面图形来想象三维立体。因此，学习本课程需要始终牢记把物体的投影与物体的形状和结构紧密联系在一起，不断地“由物绘图”和“由图想物”，既要思考视图的形成，又要想象物体的形状和结构，在图物相互转换的过程中，逐步提高绘图与读图的能力。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    {
        key: 'section1.3.3', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.3.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.3.3.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.3.3.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）学练结合。在学习本课程的过程中，课前预习、课中学习与课后练习紧密结合，在学中练、在练中学。课前预习应结合任务工单进行，通过回答引导问题熟悉各任务的基本知识，把握其重点和难点；课中学习应紧密跟随教师的引导分析和示范教学，认真学习相应的知识与技能；课后练习要在课中学习后及时进行，以便巩固课中学习所获取的知识与技能。进行课后练习时，应正确使用尺规绘图工具，严格按照正确的绘图方法和绘图步骤进行绘图技能训练，做到投影正确、尺寸齐全、字体工整、图线分明、图面干净。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    {
        key: 'section1.3.4', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section1.3.4.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.3.4.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.3.4.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）严格执行国家标准。图样是国际工程界通用的技术语言，是根据国际上共同遵守的规则绘制的。自1959年国家标准《机械制图》发布至今，国家相继多次对该标准进行了修订，并且又陆续制定了各专业制图标准共同遵守的通则性规定——国家标准《技术制图》。因此，无论是学习本课程还是今后走向工作岗位，我们都必须严格遵守国家标准的各项规定，牢记国家标准中的规定画法、特殊表示法、尺寸注法和技术要求的注法等，养成严谨、细致的作图习惯和一丝不苟的工作作风。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },

]
export default content
